import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    counts: [],
    invoice_tab_counts: [],
    freelance_order_scoop:[],
    freelance_list:[],
    get_invoice_generation:[],
    freelance_jobs_report:[],
    job_summary:[],
    single_job_summary:[]
}

const FreelanceSlice = createSlice({
    name: "FreelanceSlice",
    initialState,
    reducers: {
        setFlCounts: (state, action) => ({
            ...state,
            counts: action.payload
        }),
        setFlInvoiceCounts: (state, action) => ({
            ...state,
            invoice_tab_counts: action.payload
        }),
        setFreelanceDashboardData: (state, action) => ({
            ...state,
            freelance_order_scoop: action.payload
        }),
        setFreelanceUserListing: (state, action) => ({
            ...state,
            freelance_list: action.payload
        }),
        setFreelanceUserListingFinal: (state, action) => ({
            ...state,
            get_invoice_generation: action.payload
        }),
        setJobsFromTmsSummeryViewSearch: (state, action) => ({
            ...state,
            freelance_jobs_report: action.payload
        }),
        setjobSummeryDetailsGet: (state, action) => ({
            ...state,
            job_summary: action.payload
        }),
        setgetOneJobsummury: (state, action) => ({
            ...state,
            single_job_summary: action.payload
        }),
    }
})

export const {setFlCounts,setFlInvoiceCounts, setFreelanceDashboardData,setFreelanceUserListing,setFreelanceUserListingFinal, setJobsFromTmsSummeryViewSearch,setjobSummeryDetailsGet,setgetOneJobsummury} = FreelanceSlice.actions

export default FreelanceSlice.reducer;